// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import CenterApp from "./CenterApp";
import Center from "./Center";
import DashboardsApp from "./DashboardsApp";
import DuchetDashboardPage, { DuchetCardsPage } from "./DuchetDashboardPage";
import HospitalDashboardsPage from "./HospitalDashboardsPage";
import VaccinationDashboardPage, { VaccinationCardsPage, VaccinationOverduePage,
  VaccinationExemptionsPage, VaccinationAreasPage,
  VaccinationImmunoPage } from "./VaccinationDashboardPage";

const pathname = window.location.pathname || "/";

function Root() {
  let content: JSX.Element;

  if (pathname.startsWith("/dashboards/vaccination/exemptions")) {
    // медотводы — третий вид документа, не прививка и не просрочка
    content = <VaccinationExemptionsPage />;
  } else if (pathname.startsWith("/dashboards/vaccination/areas")) {
    // список УЧАСТКОВ по охвату — не люди и не документы
    content = <VaccinationAreasPage />;
  } else if (pathname.startsWith("/dashboards/vaccination/overdue")) {
    // пофамильный список просрочки — люди БЕЗ прививки, отдельно от таблицы прививок
    content = <VaccinationOverduePage />;
  } else if (pathname.startsWith("/dashboards/vaccination/immuno")) {
    // приёмы по иммунопрофилактике — протоколы осмотра из МИС, не прививки
    content = <VaccinationImmunoPage />;
  } else if (pathname.startsWith("/dashboards/vaccination/cards")) {
    content = <VaccinationCardsPage />;
  } else if (pathname.startsWith("/dashboards/vaccination")) {
    content = <VaccinationDashboardPage />;
  } else if (pathname.startsWith("/dashboards/duchet/cards")) {
    content = <DuchetCardsPage />;
  } else if (pathname.startsWith("/dashboards/duchet")) {
    content = <DuchetDashboardPage />;
  } else if (pathname.startsWith("/dashboards/mother-hospital")) {
    content = <HospitalDashboardsPage />;
  } else if (pathname.startsWith("/dashboards/hospital")) {
    content = <HospitalDashboardsPage />;
  } else if (pathname.startsWith("/dashboards/app")) {
    content = <DashboardsApp />;
  } else if (pathname.startsWith("/center_app")) {
    content = <CenterApp />;
  } else if (pathname.startsWith("/dashboards/situation-center") || pathname.startsWith("/center")) {
    content = <Center />;
  } else {
    content = <App />;
  }

  // Важно: оставь обёртку так, как было раньше в твоём проекте.
  // Если раньше был StrictMode — оставь. Если не было — лучше не добавлять сейчас.
  return <React.StrictMode>{content}</React.StrictMode>;
}

const el = document.getElementById("root")!;
ReactDOM.createRoot(el).render(<Root />);


/* src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import CenterApp from "./CenterApp";
import Center from "./Center";
import DashboardsApp from "./DashboardsApp";

const pathname = window.location.pathname || "/";

function Root() {
  let content: JSX.Element;

  if (pathname.startsWith("/dashboards/app")) {
    content = <DashboardsApp />;
  } else if (pathname.startsWith("/center_app")) {
    content = <CenterApp />;
  } else if (pathname.startsWith("/dashboards/situation-center") || pathname.startsWith("/center")) {
    content = <Center />;
  } else {
    content = <App />;
  }

  // Важно: оставь обёртку так, как было раньше в твоём проекте.
  // Если раньше был StrictMode — оставь. Если не было — лучше не добавлять сейчас.
  return <React.StrictMode>{content}</React.StrictMode>;
}

const el = document.getElementById("root")!;
ReactDOM.createRoot(el).render(<Root />);
*/
